import { useState } from 'react';
import './Resume.css';

export default function Resume() {
  const [resume] = useState({
    title: 'Senior Product Designer',
    experience: [
      {
        id: 1,
        title: 'Senior Product Designer',
        company: 'TechCorp',
        location: 'San Francisco, CA',
        startDate: '2020',
        endDate: 'Present',
        description: 'Leading the design of enterprise products and design systems.',
      },
      {
        id: 2,
        title: 'Product Designer',
        company: 'DesignHub',
        location: 'New York, NY',
        startDate: '2018',
        endDate: '2020',
        description: 'Designed and shipped multiple features for the core product.',
      },
    ],
    education: [
      {
        id: 1,
        degree: 'Master of Design',
        school: 'Stanford University',
        field: 'Human-Computer Interaction',
        year: '2018',
      },
      {
        id: 2,
        degree: 'Bachelor of Fine Arts',
        school: 'Rhode Island School of Design',
        field: 'Graphic Design',
        year: '2016',
      },
    ],
    skills: [
      'UI/UX Design',
      'User Research',
      'Prototyping',
      'Figma',
      'Sketch',
      'Adobe Creative Suite',
      'HTML/CSS',
      'Design Systems',
    ],
  });

  return (
    <div className="resume-container">
      <div className="resume-card">
        <div className="resume-header">
          <div className="resume-header-content">
            <h2>My Resume</h2>
            <p>Your professional experience and education</p>
          </div>
          <button
            type="button"
            className="download-button"
          >
            Download PDF
          </button>
        </div>
        <div className="resume-content">
          <div className="section">
            <h3 className="section-title">Experience</h3>
            <div>
              {resume.experience.map((exp) => (
                <div key={exp.id} className="timeline-item">
                  <div className="timeline-header">
                    <h4 className="timeline-title">{exp.title}</h4>
                    <span className="timeline-date">
                      {exp.startDate} - {exp.endDate}
                    </span>
                  </div>
                  <div className="timeline-company">{exp.company}</div>
                  <div className="timeline-location">{exp.location}</div>
                  <p className="timeline-description">{exp.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">Education</h3>
            <div>
              {resume.education.map((edu) => (
                <div key={edu.id} className="timeline-item">
                  <div className="timeline-header">
                    <h4 className="timeline-title">{edu.degree}</h4>
                    <span className="timeline-date">{edu.year}</span>
                  </div>
                  <div className="timeline-company">{edu.school}</div>
                  <div className="timeline-location">{edu.field}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">Skills</h3>
            <div className="skills-container">
              {resume.skills.map((skill, index) => (
                <span key={index} className="skill-tag">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
